__turbopack_context__.v({
  "header": "FormattedQuestionnaires-module__GPF9ha__header",
  "questionnaire": "FormattedQuestionnaires-module__GPF9ha__questionnaire",
  "questionnaireHeader": "FormattedQuestionnaires-module__GPF9ha__questionnaireHeader",
  "questionnaireItem": "FormattedQuestionnaires-module__GPF9ha__questionnaireItem",
  "questionnaireText": "FormattedQuestionnaires-module__GPF9ha__questionnaireText",
});
